import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Notre Solution', href: '#solution' },
    { label: 'Cartes', href: '#cards' },
    { label: 'Fidélité', href: '#loyalty' },
    { label: 'Entreprises', href: '#business' },
    { label: 'App Mobile', href: '#app' },
    { label: 'Partenaires', href: '#partners' },
    { label: 'Contact', href: '#contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center space-x-2">
            <img
              src={companyInfo.logo}
              alt="KIPAY"
              className="h-16 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:text-[#6B2C91] ${
                  isScrolled ? 'text-gray-700' : 'text-gray-700'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Buttons + Contact */}
          <div className="hidden lg:flex flex-col items-end">
            <div className="flex items-center space-x-4 mb-1">
              <Button
                variant="ghost"
                size="sm"
                className="text-[#6B2C91] hover:bg-[#6B2C91]/10"
              >
                Connexion
              </Button>
              <Button
                size="sm"
                className="bg-[#6B2C91] hover:bg-[#5a2579] text-white px-4"
              >
                Commander Ma Carte
              </Button>
            </div>
            <div className="flex items-center space-x-4 text-xs text-gray-600">
              <span className="flex items-center gap-1">
                <Phone className="w-3 h-3" />
                27 22 41 25 25 / 05 06 06 55 06
              </span>
              <span className="flex items-center gap-1">
                <Mail className="w-3 h-3" />
                contact@kipay.net
              </span>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 py-4">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-gray-700 hover:text-[#6B2C91] px-4 py-2 transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              <div className="px-4 pt-4 border-t border-gray-100 space-y-3">
                <Button
                  variant="outline"
                  className="w-full border-[#6B2C91] text-[#6B2C91]"
                >
                  Connexion
                </Button>
                <Button className="w-full bg-[#6B2C91] hover:bg-[#5a2579] text-white">
                  Commander Ma Carte
                </Button>
                <div className="text-center text-xs text-gray-600 pt-2 space-y-1">
                  <p className="flex items-center justify-center gap-1">
                    <Phone className="w-3 h-3" />
                    27 22 41 25 25 / 05 06 06 55 06
                  </p>
                  <p className="flex items-center justify-center gap-1">
                    <Mail className="w-3 h-3" />
                    contact@kipay.net
                  </p>
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
